export default {
  EMERGENCY_FUND_INVESTOR_GOAL_REPOSITORY: Symbol.for('EMERGENCY_FUND_INVESTOR_GOAL_REPOSITORY'),
  EMERGENCY_FUND_INVESTOR_GOAL_STATE_MANAGER: Symbol.for('EMERGENCY_FUND_INVESTOR_GOAL_STATE_MANAGER'),
  CREATE_EMERGENCY_FUND_INVESTOR_GOAL_STATE_MANAGER: Symbol.for('CREATE_EMERGENCY_FUND_INVESTOR_GOAL_STATE_MANAGER'),
  GET_EMERGENCY_FUND_INVESTOR_GOAL_QUERY: Symbol.for('GET_EMERGENCY_FUND_INVESTOR_GOAL_QUERY'),
  UPDATE_EMERGENCY_FUND_INVESTOR_GOAL_COMMAND: Symbol.for('UPDATE_EMERGENCY_FUND_INVESTOR_GOAL_COMMAND'),
  UPDATE_PLAN_EMERGENCY_FUND_INVESTOR_GOAL_COMMAND: Symbol.for('UPDATE_PLAN_EMERGENCY_FUND_INVESTOR_GOAL_COMMAND'),
};
